import AuthorizeConfirmModal from "./AuthorizeConfirmModal";

export default AuthorizeConfirmModal;
